interface LiveVideoProps {
  size?: string | number;
  className?: string;
}

const IconLiveVideo = (props: LiveVideoProps) => {
  const size = props.size ?? '24';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      x="0"
      y="0"
      viewBox="0 0 32 32"
      xmlSpace="preserve"
      fillRule="evenodd"
    >
      <g>
        <path
          fill="#d5242e"
          d="M20.366 21.247a1.002 1.002 0 0 0 0 1.506l8 7a1.001 1.001 0 0 0 1.66-.753V15a.999.999 0 0 0-1.66-.753z"
          opacity="1"
          data-original="#d5242e"
        ></path>
        <path
          fillOpacity=".1"
          d="M20.366 21.247a1.002 1.002 0 0 0 0 1.506l8 7a1.001 1.001 0 0 0 1.66-.753V15a.999.999 0 0 0-1.66-.753z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          fill="#d5242e"
          d="M22 14.938a3 3 0 0 0-3-2.999H5a3 3 0 0 0-3 3v13.997a3 3 0 0 0 3 2.999h14a3 3 0 0 0 3-3z"
          opacity="1"
          data-original="#d5242e"
        ></path>
        {/* <circle cx="121" cy="7" r="1" fill="#f0b638" transform="rotate(180 61.5 4.5)" opacity="1" data-original="#f0b638"></circle> */}
        <path
          fill="#f2f2f2"
          d="M15.553 22.832a1 1 0 0 0 0-1.664l-6.003-4A1 1 0 0 0 7.994 18v8a1 1 0 0 0 1.556.832z"
          opacity="1"
          data-original="#f2f2f2"
        ></path>
        <path
          fill="#89201d"
          d="M5 1v8a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2H7V1a1 1 0 0 0-2 0zM12 1v8a1 1 0 0 0 2 0V1a1 1 0 0 0-2 0zM26 1v8a1 1 0 0 0 2 0V1a1 1 0 0 0-2 0z"
          opacity="1"
          data-original="#89201d"
        ></path>
        <path
          fill="#89201d"
          d="M27 2h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2zM27 10h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2zM26.939 6h3.332a1 1 0 0 0 0-2h-3.332a1 1 0 0 0 0 2zM16.064 1.351l3 8a1 1 0 0 0 1.872 0l3-8a1 1 0 1 0-1.872-.702L20 6.152 17.936.649a1 1 0 1 0-1.872.702z"
          opacity="1"
          data-original="#89201d"
        ></path>
      </g>
    </svg>
  );

  // return (
  //     <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} className={props.className} viewBox="0 0 32 32">
  //         <path fill="currentColor" d="M6.001 7.5a4.5 4.5 0 0 1 4.5-4.5h15a4.5 4.5 0 0 1 4.5 4.5v10a4.5 4.5 0 0 1-4.5 4.5h-6.309c-.6-1.316-1.876-2.17-3.192-2.422V18a3 3 0 0 1 3-3h5a3 3 0 0 1 3 3v1.5a2.5 2.5 0 0 0 1.001-2v-10a2.5 2.5 0 0 0-2.5-2.5h-15a2.5 2.5 0 0 0-2.5 2.5v.314a6.5 6.5 0 0 0-2 1.062zM24 17h-5a1 1 0 0 0-1 1v2h7v-2a1 1 0 0 0-1-1m-6.585 5a2.55 2.55 0 0 1 .627 1.873c-.135 2.074-.918 3.68-2.403 4.728C14.206 29.612 12.262 30 10 30c-2.248 0-4.156-.384-5.566-1.386c-1.458-1.037-2.228-2.619-2.417-4.65C1.854 22.218 3.35 21 4.872 21h10.319q.156 0 .313.017c.729.08 1.43.43 1.91.983M4.873 23c-.585 0-.897.43-.865.78c.15 1.603.713 2.584 1.584 3.204C6.511 27.637 7.927 28 10 28c2.086 0 3.543-.368 4.486-1.033c.89-.628 1.455-1.617 1.56-3.223c.022-.333-.283-.744-.855-.744zM25 10.5a3.5 3.5 0 1 1-7 0a3.5 3.5 0 0 1 7 0m-2 0a1.5 1.5 0 1 0-3 0a1.5 1.5 0 0 0 3 0M15 14a5 5 0 1 1-10 0a5 5 0 0 1 10 0m-2 0a3 3 0 1 0-6 0a3 3 0 0 0 6 0" />
  //     </svg>
  // )
};

export default IconLiveVideo;
